import { addendumChangeType } from '../../utils/locale'

export function filterAddendumRemovedItems (services = []) {
  return services.filter(section => {
    if (section.addendumLabel === addendumChangeType.removed) {
      return false
    }
    if (section.lineItems) {
      section.lineItems = section.lineItems.filter(item => {
        if (item.addendumLabel === addendumChangeType.removed) {
          return false
        }
        if (item.options) {
          item.options = item.options.filter(option => option.addendumLabel !== addendumChangeType.removed)
        }
        return true
      })
    }
    return !section.forReference || section.lineItems.length > 0
  })
}
